import { faEdit } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import React, { useMemo, useState } from 'react'
import EditEntryValueModel from "./editEntryValueModel"
import PhotoValue from "./photoValue"
import ReportValue from "./reportValue"

const EntryValue = ({ entry, field, map }) => {
  const [modalIsOpen, setModalIsOpen] = useState(false)

  const valueString = useMemo(() => {
    if (field.data_type === "geo_json") {
      return entry?.value?.join(', ')
    } else if (Array.isArray(entry?.value)) {
      return entry?.value?.join(', ')
    } else if (field.data_type === 'photos') {
      return <PhotoValue entry={entry} />
    } else {
      return entry?.value
    }
  }, [entry, field, map])

  const openModal = () => setModalIsOpen(true)
  const closeModal = () => setModalIsOpen(false)

  switch (field.data_type) {
    case 'photos':
      return (
        <>
          <PhotoValue entry={entry} />
        </>
      )
    case 'gis_report':
      return (
        <>
          <ReportValue entry={entry} field ={field} />
        </>
      )
    default:
      return (
        <div className="w-40 z-10 flex flex-row">
          {entry && <>
            <div
              className='flex flex-row items-center justify-between gap-x-2 cursor-pointer group hover:bg-blue-100 w-full h-full'
              onClick={openModal}>
              <div className='h-4 whitespace-nowrap truncate text-xs'>{valueString}</div>
              <FontAwesomeIcon
                className='text-xs opacity-0 group-hover:opacity-100 text-gray-600'
                icon={faEdit}
              />
            </div>
            {modalIsOpen && (
              <EditEntryValueModel closeModal={closeModal} entry={entry} field={field} map={map}
                valueString={valueString} />
            )}
          </>}
        </div>
      )
  }
}

export default EntryValue
